import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import OrgRegistryBasicInfoComponent from './org-registry-basic-info.component';
import OrgRegistryKeyInfoComponent from './org-registry-key.component';
import OrgRegistryBrandInfoComponent from './brand-mapping/org-registry-brand-Info.component';
import DBNBizCollectionMappings from './dbnbiz-collections-mappings';
import DBNBizDiscountMappings from './dbnbiz-discount-mappings';
import DBNBizCatalogMappings from './dbnbiz-catalog-mappings';
import DBNBizDomainMappings from './dbnbiz-domain-mappings';
import DBNBizCategoryMappings from './dbnbiz-category-mappings';
import DBNBizBrandMappingListComponent from './dbnbiz-brand-mapping/containers/brand-mappings';
import DBNBizTickets from './dbnbiz-tickets/containers/dbnbiz-tickets';

export const OrgRegistryComponent = ({ dbnpregistries, orgRegistries,
  deliveryPreference, accountType, deleteKeys, onFormItemChange, keys, onFormChange, orgRegistry, fetchAcount, accounts,
  shippingProviders, id, selectedOrgRegistry, shippingTypes, back, handleFormSubmit, changeImage, deleteSelectedBrands,
  getIsFavRecordDeletable, onFormFavItemChange, deleteselectedFavIcon, changeFavImage, logoFiles, onFormLogoItemChange,
  getIsLogoRecordDeletable, faviconSize, changeLogoImage, logoBackground, deleteselectedLogo, onFormItemBrandChange,
  getIsBrandRecordDeletable, brandMappings, handleOpen, handleClose, shippingOptionList
}: any) => {

  const tabItems = [
    {
      id: 0,
      title: 'Basic Details',
      component: <OrgRegistryBasicInfoComponent
        id={id}
        selectedOrgRegistry={selectedOrgRegistry}
        shippingTypes={shippingTypes}
        shippingProviders={shippingProviders}
        accounts={accounts}
        accountType={accountType}
        deliveryPreference={deliveryPreference}
        fetchAcount={fetchAcount}
        orgRegistry={orgRegistry}
        onFormChange={onFormChange}
        dbnpregistries={dbnpregistries}
        shippingOptionList={shippingOptionList}
        orgRegistries={orgRegistries}
      />,
      isVisible: true,
    },
    {
      id: 1,
      title: 'Key Details',
      component: <OrgRegistryKeyInfoComponent
        keys={keys}
        onFormItemChange={onFormItemChange}
        deleteKeys={deleteKeys}
      />,
      isVisible: true,
    },
    // {
    //   id: 2,
    //   title: 'Brand Mapping',
    //   component: <OrgRegistryBrandInfoComponent
    //     changeImage={changeImage}
    //     deleteSelectedBrands={deleteSelectedBrands}
    //     getIsBrandRecordDeletable={getIsBrandRecordDeletable}
    //     handleClose={handleClose}
    //     handleOpen={handleOpen}
    //     onFormItemBrandChange={onFormItemBrandChange}
    //     logoFiles={logoFiles}
    //     changeFavImage={changeFavImage}
    //     deleteselectedFavIcon={deleteselectedFavIcon}
    //     onFormFavItemChange={onFormFavItemChange}
    //     getIsFavRecordDeletable={getIsFavRecordDeletable}
    //     onFormLogoItemChange={onFormLogoItemChange}
    //     getIsLogoRecordDeletable={getIsLogoRecordDeletable}
    //     faviconSize={faviconSize}
    //     changeLogoImage={changeLogoImage}
    //     logoBackground={logoBackground}
    //     deleteselectedLogo={deleteselectedLogo}
    //     brandMappings={brandMappings}
    //   />,
    //   isVisible: id > 0 ? true : false,
    // },
    {
      id: 2,
      title: 'DBNBiz Brand Mapping',
      component: <DBNBizBrandMappingListComponent
        orgRegistry={orgRegistry}
      />,
      isVisible: id > 0 ? true : false,
    },
    // {
    //   id: 3,
    //   title: 'DBNBiz Domain',
    //   component: <DBNBizDomainMappings
    //     orgRegistry={orgRegistry}
    //   />,
    //   isVisible: id > 0 ? true : false,
    // },
    {
      id: 4,
      title: 'DBNBiz Category',
      component: <DBNBizCategoryMappings
        orgRegistry={orgRegistry}
      />,
      isVisible: id > 0 ? true : false,
    },
    // {
    //   id: 5,
    //   title: 'DBNBiz Products',
    //   component: <DBNBizProducts
    //     orgRegistry={orgRegistry}
    //   />,
    //   isVisible: id > 0 ? true : false,
    // },
    {
      id: 6,
      title: 'DBNBiz Catalogs',
      component: <DBNBizCatalogMappings
        orgRegistry={orgRegistry}
      />,
      isVisible: id > 0 ? true : false,
    },
    //  {
    //   id: 7,
    //   title: 'DBNBiz Orders',
    //   component: <DBNBizOrders
    //     orgRegistry={orgRegistry}
    //   />,
    //   isVisible: id > 0 ? true : false,
    // },
    {
      id: 8,
      title: 'DBNBiz Collections',
      component: <DBNBizCollectionMappings
        orgRegistry={orgRegistry}
      />,
      isVisible: id > 0 ? true : false,
    },
    {
      id: 9,
      title: 'DBNBiz Discounts',
      component: <DBNBizDiscountMappings
        orgRegistry={orgRegistry}
      />,
      isVisible: id > 0 ? true : false,
    },
    {
      id: 10,
      title: 'DBNBiz Tickets',
      component: <DBNBizTickets
        orgRegistry={orgRegistry}
      />,
      isVisible: id > 0 ? true : false,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        {orgRegistry?.IsProxyNetwork === false && (
          <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            onClick={handleFormSubmit}
            type="submit"
          >
            Save
          </button>
        )}
      </div>
    </div>
  )
}
export default OrgRegistryComponent;
